import { render, staticRenderFns } from "./order_loader.vue?vue&type=template&id=6e48dda3&scoped=true"
import script from "./order_loader.vue?vue&type=script&lang=js"
export * from "./order_loader.vue?vue&type=script&lang=js"
import style0 from "./order_loader.vue?vue&type=style&index=0&id=6e48dda3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e48dda3",
  null
  
)

export default component.exports